import { render } from "./ConfirmNewPassword.vue?vue&type=template&id=fa76ca16&scoped=true"
import script from "./ConfirmNewPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmNewPassword.vue?vue&type=script&lang=js"

import "./ConfirmNewPassword.vue?vue&type=style&index=0&id=fa76ca16&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa76ca16"]])

export default __exports__